module.exports = __webpack_public_path__ + "static/media/pinIconDefault.776aba85.svg";